import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{documentRequestUserId}/schedule-i']['POST'];
type Input = ThisApi['params'];

const syncIncomeDataWithSchedules = async ({ documentRequestUserId }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.post(`/document-request-users/${documentRequestUserId}/schedule-i`);
  return response.data;
};

export default syncIncomeDataWithSchedules;
